import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["open", "onClose", "builders", "sellers", "onShowPhoneClick", "openContactsSellerPhoneStyles", "openContactsBuilderPhoneStyles"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { filterBuilders } from '../../utils/filterBuilders';
import { filterSellers } from '../../utils/filterSellers';
import { getIsLeadFactory } from '../../utils/isLeadFactory';
import { isShowPhoneImmediately } from '../../utils/isShowPhoneImmediately';
import { isEmptyRendering } from '../../utils/isEmptyRendering';
import { PhonePopupModal } from '../PhonePopupModal';
import { InfosPopupModal } from '../InfosPopupModal';
import { jsx as _jsx } from "react/jsx-runtime";
export var ModalPhone = function ModalPhone(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    builders = _ref.builders,
    sellers = _ref.sellers,
    onShowPhoneClick = _ref.onShowPhoneClick,
    openContactsSellerPhoneStyles = _ref.openContactsSellerPhoneStyles,
    openContactsBuilderPhoneStyles = _ref.openContactsBuilderPhoneStyles,
    commonProps = _objectWithoutProperties(_ref, _excluded);
  var buildersWithPhones = filterBuilders(builders);
  var sellersWithPhones = filterSellers(sellers);
  var isLeadFactory = getIsLeadFactory(sellersWithPhones);
  var showPhoneImmediately = isShowPhoneImmediately({
    builders: buildersWithPhones,
    sellers: sellersWithPhones,
    isLeadFactory: isLeadFactory
  });
  if (isEmptyRendering({
    builders: buildersWithPhones,
    sellers: sellersWithPhones
  })) {
    return null;
  }
  if (showPhoneImmediately) {
    return /*#__PURE__*/_jsx(PhonePopupModal, _objectSpread(_objectSpread({
      open: open,
      onClose: onClose
    }, commonProps), {}, {
      onPhoneOpen: onShowPhoneClick,
      builders: buildersWithPhones,
      sellers: sellersWithPhones
    }));
  }
  return /*#__PURE__*/_jsx(InfosPopupModal, _objectSpread(_objectSpread({}, commonProps), {}, {
    open: open,
    onClose: onClose,
    builders: buildersWithPhones,
    sellers: sellersWithPhones,
    onPhoneOpen: onShowPhoneClick,
    openContactsSellerPhoneStyles: openContactsSellerPhoneStyles,
    openContactsBuilderPhoneStyles: openContactsBuilderPhoneStyles
  }));
};